export { default } from './FrequestRecentSwitcher';



// WEBPACK FOOTER //
// ./src/components/Search/ContactSearch/FrequentRecentSwitcher/index.js